<div class="container mt-4">
	<div class="d-flex justify-content-between align-items-center mb-4">
		<h1>Contas a Receber</h1>
		<span class="badge bg-secondary">Total: {{ totalElements }}</span>
	</div>
	<hr />

	<div class="mb-3">
		<div class="input-group">
			<input
				type="text"
				class="form-control"
				placeholder="Pesquisar por nome do cliente ou ID da venda"
				[(ngModel)]="searchTerm"
				(keyup.enter)="pesquisar()">
			<button class="btn btn-outline-secondary" type="button" (click)="pesquisar()">Pesquisar</button>
			<button class="btn btn-outline-secondary" type="button" (click)="limparPesquisa()">Limpar</button>
		</div>
	</div>

	<div *ngIf="isLoading" class="alert alert-info" role="alert">
		Carregando contas a receber...
	</div>

	<div class="table-responsive" *ngIf="!isLoading">
		<table class="table table-striped table-hover">
			<thead class="thead-dark">
				<tr>
					<th scope="col">Venda</th>
					<th scope="col">Cliente</th>
					<th scope="col" class="text-center">Forma de Pagamento</th>
					<th scope="col" class="text-center">Data da Venda</th>
					<th scope="col" class="text-end">Total Venda</th>
					<th scope="col" class="text-end">Valor Recebido</th>
					<th scope="col" class="text-end">Saldo Devedor</th>
					<th scope="col" class="text-center">Status</th>
					<th scope="col" class="text-center">Ação</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let conta of contasReceber">
					<td>{{ conta.idVenda }}</td>
					<td>{{ conta.nomeRazaoSocial }}</td>
					<td class="text-center">{{ conta.formaPagamento }}</td>
					<td class="text-center">{{ conta.dataVenda | date:'dd/MM/yyyy HH:mm' }}</td>
					<td class="text-end">{{ conta.totalVenda | currency:'BRL' }}</td>
					<td class="text-end">{{ conta.valorRecebido | currency:'BRL' }}</td>
					<td class="text-end fw-bold text-danger">{{ conta.saldoDevedor | currency:'BRL' }}</td>
					<td class="text-center">{{ conta.statusVenda }}</td>
					<td class="text-center">
						<button type="button" class="btn btn-outline-primary btn-sm" (click)="visualizarConta(conta.idVenda)">Visualizar</button>
					</td>
				</tr>
				<tr *ngIf="contasReceber.length === 0">
					<td colspan="8" class="text-center text-muted py-4">
						Nenhuma conta a receber pendente encontrada.
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<nav *ngIf="!isLoading && totalPages > 1" aria-label="Page navigation" class="pagination-container">
		<ul class="pagination justify-content-center">
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage === 0">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
			</li>
			<li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
			</li>
			<li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
				<a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
			</li>
		</ul>
	</nav>
</div>
